import { sortArray } from "components/results/analysis-results/sortUtil";
import { GroupTableFathom } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import gap from "report/common/gap";
import getLayer from "report/common/layer";
import page from "report/common/page";
import tableColumn from "report/common/table-column";
import getTitle from "report/common/title";

const get = (
  t: any,
  grouped: GroupTableFathom,
  aggregationUnits: string[],
  unit: string,
  currency: string,
  layerTitle: { [key: string]: string }
): Content[] => {
  const layerArray = Object.keys(grouped)
    .sort((a, b) => {
      return sortArray.indexOf(a) - sortArray.indexOf(b);
    })
    .map((e) => {
      const title = layerTitle[e];
      const titleTranslate =
        title && "" !== title ? t(`legend.${title}`) : undefined;
      if (e === "FL_Pluvial_Global_Fathom") {
        return [
          getLayer(t, e, 10, 1),
          gap(10),
          tableColumn(
            t,
            grouped[e]["defended"],
            aggregationUnits,
            titleTranslate,
            unit,
            currency
          ),
          gap(30)
        ];
      }
      const row = Object.keys(grouped[e])
        .sort((a) => (a === "undefended" ? -1 : 1))
        .map((defended) => {
          if (defended === "defended")
            return [
              gap(10),
              {
                stack: [
                  getTitle(t("report." + defended), 10),
                  tableColumn(
                    t,
                    grouped[e][defended],
                    aggregationUnits,
                    titleTranslate,
                    unit,
                    currency
                  )
                ],
                unbreakable: true
              }
            ];
          if (defended === "undefended")
            return [
              gap(10),
              {
                stack: [
                  getTitle(t("report." + defended), 10),
                  tableColumn(
                    t,
                    grouped[e][defended],
                    aggregationUnits,
                    titleTranslate,
                    unit,
                    currency
                  )
                ],
                unbreakable: true
              }
            ];
          return [gap(10)];
        });
      return [
        getLayer(t, e, 10, 1),
        ...row,
        // page()
        gap(30)
      ];
    });

  return [layerArray];
};

export default get;
